import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import DevisPage from './pages/DevisPage';
import PrivacyPage from './pages/PrivacyPage';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/immobilier" element={<HomePage sector="immobilier" />} />
        <Route path="/logiciel_IA" element={<HomePage sector="logiciel_IA" />} />
        <Route path="/audit" element={<HomePage sector="audit" />} />
        <Route path="/devis" element={<DevisPage />} />
        <Route path="/confidentialite" element={<PrivacyPage />} />
      </Routes>
    </Router>
  );
}

export default App;